'use client'

import { createContext, useState } from 'react'

export const ImageContext = createContext('')

export const ImageProvider = ({ children }) => {
  const [topImages, setTopImages] = useState({
    all: [],
    Hyperreal: [],
    Anime: [],
    Hyperanime: [],
    Real: [],
    'K-Pop': [],
    Fur: [],
    Furtoon: [],
    'Anime XL': [],
    'Cinematic XL': [],
    'Hardcore XL': [],
    'Pony XL': [],
    'Pony Anime XL': [],
    'Pony Photo XL': [],
    'Pony Illustration XL': [],
    'Pony Render XL': [],
    'Pony XL 2': [],
    'Pony Photo XL 2': [],
    'Cinematic Flame': [],
    'Hardcore Flame': [],
  })

  const [trendingImages, setTrendingImages] = useState({
    all: [],
    Hyperreal: [],
    Anime: [],
    Hyperanime: [],
    Real: [],
    'K-Pop': [],
    Fur: [],
    Furtoon: [],
    'Anime XL': [],
    'Cinematic XL': [],
    'Hardcore XL': [],
    'Pony XL': [],
    'Pony Anime XL': [],
    'Pony Photo XL': [],
    'Pony Illustration XL': [],
    'Pony Render XL': [],
    'Pony XL 2': [],
    'Pony Photo XL 2': [],
    'Cinematic Flame': [],
    'Hardcore Flame': [],
  })

  const [videoImages, setVideoImages] = useState({
    all: [],
    Hyperreal: [],
    Anime: [],
    Hyperanime: [],
    Real: [],
    'K-Pop': [],
    Fur: [],
    Furtoon: [],
    'Anime XL': [],
    'Cinematic XL': [],
    'Hardcore XL': [],
    'Pony XL': [],
    'Pony Anime XL': [],
    'Pony Photo XL': [],
    'Pony Illustration XL': [],
    'Pony Render XL': [],
    'Pony XL 2': [],
    'Pony Photo XL 2': [],
    'Cinematic Flame': [],
    'Hardcore Flame': [],
  })

  const [featuredImages, setFeaturedImages] = useState({
    all: [],
    Hyperreal: [],
    Anime: [],
    Hyperanime: [],
    Real: [],
    'K-Pop': [],
    Fur: [],
    Furtoon: [],
    'Anime XL': [],
    'Cinematic XL': [],
    'Hardcore XL': [],
    'Pony XL': [],
    'Pony Anime XL': [],
    'Pony Photo XL': [],
    'Pony Illustration XL': [],
    'Pony Render XL': [],
    'Pony XL 2': [],
    'Pony Photo XL 2': [],
    'Cinematic Flame': [],
    'Hardcore Flame': [],
  })

  const [userImages, setUserImages] = useState({})
  const [userLikedImages, setUserLikedImages] = useState({})
  const [usernames, setUsernames] = useState({})
  const [bios, setBios] = useState({})
  const [profiles, setProfiles] = useState({})

  const [userPlans, setUserPlans] = useState({})
  const [userGems, setUserGems] = useState({})
  const [hasUserImagesFetched, setHasUserImagesFetched] = useState({})
  const [hasUserLikedImagesFetched, setHasUserLikedImagesFetched] = useState({})

  const [hasUserPersonalImagesFetched, setHasUserPersonalImagesFetched] =
    useState(false)
  const [userPersonalImages, setUserPersonalImages] = useState([])

  const [activeButton, setActiveButton] = useState('Trending')
  const [model, setModel] = useState('all')
  const [totalImageCount, setTotalImageCount] = useState(0)
  const [visibleImages, setVisibleImages] = useState(15)
  const [images, setImages] = useState([])
  const [activeButtonProfile, setActiveButtonProfile] = useState('Posts')
  const [format, setFormat] = useState('all')

  const [filteredImages, setFilteredImages] = useState([])
  const [dateRange, setDateRange] = useState('month')

  return (
    <ImageContext.Provider
      value={{
        activeButton,
        setActiveButton,
        topImages,
        setTopImages,
        trendingImages,
        setTrendingImages,
        featuredImages,
        setFeaturedImages,
        videoImages,
        setVideoImages,
        model,
        setModel,
        userImages,
        setUserImages,
        userLikedImages,
        setUserLikedImages,
        hasUserImagesFetched,
        setHasUserImagesFetched,
        hasUserLikedImagesFetched,
        setHasUserLikedImagesFetched,
        usernames,
        setUsernames,
        userPlans,
        setUserPlans,
        userGems,
        setUserGems,
        totalImageCount,
        setTotalImageCount,
        hasUserPersonalImagesFetched,
        setHasUserPersonalImagesFetched,
        userPersonalImages,
        setUserPersonalImages,
        visibleImages,
        setVisibleImages,
        images,
        setImages,
        activeButtonProfile,
        setActiveButtonProfile,
        format,
        setFormat,
        bios,
        setBios,
        profiles,
        setProfiles,
        filteredImages,
        setFilteredImages,
        dateRange,
        setDateRange,
      }}
    >
      {children}
    </ImageContext.Provider>
  )
}
